var React = require('react');

function Xwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1807 2.21499H14.1435L9.85545 7.11593L14.9 13.785H10.9501L7.8565 9.74025L4.31667 13.785H2.35274L6.93921 8.5429L2.09998 2.21499H6.15007L8.94646 5.91205L12.1807 2.21499ZM11.4919 12.6102H12.5794L5.55911 3.32808H4.39203L11.4919 12.6102Z","fill":"black"}));
}

Xwitter.displayName = "Xwitter";

Xwitter.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Xwitter;

Xwitter.default = Xwitter;
